module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [(_vm.params[_vm.type].text) ? _c('span', [_vm._v(_vm._s(_vm.params[_vm.type].text))]) : _vm._e(), _vm._v(" "), (_vm.params[_vm.type].text === 'Scan the QR code to sign in') ? _c('img', {
    staticClass: "cursor-help",
    attrs: {
      "src": require("../../assets/images/scan_help_icon.png")
    },
    on: {
      "click": _vm.help
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.clickRouter
    }
  }, [_vm._v(_vm._s(_vm.params[_vm.type].router))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f12fd4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Foot.vue
// module id = 733
// module chunks = 1